import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { backButton } from '@telegram-apps/sdk-react';

import {
  containerStyles,
  contentHeaderStyles,
  contentMessageStyles,
  contentShapeStyles,
  contentStyles
} from '@/components/Verification/styles.ts';
import CloudExclamationShape from '@/components/common/svg/shapes/CloudExclamationShape.tsx';

const Page500 = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const canUseBackButton = backButton.isSupported() && backButton.isMounted();

    if (canUseBackButton) {
      backButton.hide();
    }

    return () => {
      if (canUseBackButton) {
        backButton.show();
      }
    };
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div style={containerStyles}>
      <div style={contentStyles}>
        <CloudExclamationShape
          width={100}
          height={100}
          secondaryColor="#000"
          style={contentShapeStyles}
        />
        <span style={contentHeaderStyles}>
          {t('error.network.page.header')}
        </span>
        <p style={contentMessageStyles}>{t('error.network.page.message')}</p>
        <button
          onClick={handleReload}
          style={{
            marginTop: '20px',
            padding: '12px 24px',
            backgroundColor: '#000000',
            color: '#ffffff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: 500,
            cursor: 'pointer'
          }}
        >
          {t('error.network.page.button')}
        </button>
      </div>
    </div>
  );
};

export default Page500;
